export default __webpack_public_path__ + "static/media/patient-medical-history-form-2.9a066bc9.jpeg";